import React, { FC, ReactNode, HTMLProps } from "react"
import "./banner.scss"

interface PrimaryBannerProps extends HTMLProps<HTMLDivElement> {
  isDark?: boolean
  children?: ReactNode
}

const PrimaryBanner: FC<PrimaryBannerProps> = (props) => {
  const { isDark = true, children, ...restProps } = props

  const bannerContainerTheme = isDark
    ? "banner-container-dark"
    : "banner-container-light"

  const bannerEdgeTheme = isDark ? "banner-edge-dark" : "banner-edge-light"

  return (
    <div className={"banner-container " + bannerContainerTheme} {...restProps}>
      <div className={"banner-top " + bannerEdgeTheme}></div>
      {children}
      <div className={"banner-bottom " + bannerEdgeTheme}></div>
    </div>
  )
}

export default PrimaryBanner
